module.exports = __webpack_public_path__ + "static/media/trashA.7d10046e.png";